export const FILTER_NAME = 'unit-history-report'
